<div class="work-buttons-container">
  <div class="work-buttons">
    @for (customAction of customActions; track customAction.action) {
      <button mat-button (click)="executeCustomAction(customAction)" [disabled]="working">
        <div class="button-content">
          <mat-icon class="button-icon" matTooltip="Acción">play_arrow</mat-icon>
          <span class="button-text">{{ customAction.name }}</span>
        </div>
      </button>
    }

    @for (documentType of allowedDocumentsForCreation; track documentType) {
      <button mat-button
              go-to-create
              [elementType]="documentType"
              [parent]="parentDocument"
              [parentType]="parentDocumentType"
              [disabled]="working"
              (afterClosed)="bottomSheetRef.dismiss(true)"
              openDetailsAfterClosed="modal"
              [confirmClose]="true"
      >
        <div class="button-content">
          <mat-icon class="button-icon" matTooltip="Creación de Documento">add</mat-icon>
          <span class="button-text">Crear {{ documentType | human }}</span>
        </div>
      </button>
    }

    <button mat-button *ngFor="let work of works; ;let even = even" [ngClass]="{ 'even': even }" (click)="createWork(work.id)" [disabled]="working">
      <div class="button-content">
        <mat-icon class="button-icon" matTooltip="Trabajo requerido">build</mat-icon>
        <span class="button-text">{{ work.name }}</span>
      </div>
    </button>
  </div>
</div>
